import React from 'react';
import classNames from 'classnames';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
// import { green } from '@mui/material/colors';
import { amber } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';
import { withStyles } from '@mui/styles';
import {
  classesType,
  classNameType,
  messageType,
  onCloseType,
  variantType
} from '../../types';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const styles = theme => ({
  success: {
    // backgroundColor: green[600]
    // contrastText tracks primary.main: dark text in light mode, light in dark
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main
  },
  error: {
    // backgroundColor: theme.palette.error.dark
    color: '#ffffff',
    backgroundColor: '#f44336'
  },
  info: {
    // primary.dark is a light/bright tint in both themes, so keep dark text
    color: 'rgba(0, 0, 0, 0.87)',
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  }
});

const SnackbarContentWrapper = React.forwardRef((props, ref) => {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  const renderMessage = () => {
    return (
      <span id="client-snackbar" className={classes.message}>
        <Icon className={classNames(classes.icon, classes.iconVariant)} />
        {message}
      </span>
    );
  };

  return (
    <SnackbarContent
      ref={ref}
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={renderMessage()}
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
          size="large"
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  );
});

SnackbarContentWrapper.propTypes = {
  classes: classesType.isRequired,
  className: classNameType,
  // message: PropTypes.node.isRequired,
  message: messageType.isRequired,
  onClose: onCloseType.isRequired,
  variant: variantType.isRequired
};

SnackbarContentWrapper.defaultProps = {
  className: ''
};

export default withStyles(styles)(SnackbarContentWrapper);
